import React from 'react';
import { Helmet } from 'react-helmet';
import { Restaurant } from 'src/components/Restaurant';

const RestaurantPage = () => (
  <>
    <Helmet>
      <title> Restaurant Dashboard</title>
    </Helmet>

    <Restaurant />
  </>
);

export default RestaurantPage;
